import { LineType } from '@ardoq/api-types';

export const lineTypeDashArrays: Record<LineType, number[]> = {
  [LineType.DASHED]: [10 * devicePixelRatio, 5 * devicePixelRatio],
  [LineType.DOTTED]: [2 * devicePixelRatio],
  [LineType.SOLID]: [],
};
